import React from 'react';
import { Switch } from 'antd';
import { makeStyles } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { CStandardInput } from 'src/component/Input';
import { setCategoryCreateDraft } from '../../actions/categoriesActions';
import { MultipleSelect } from '../../component/Select';

const useStyles = makeStyles({
  garbage: {
    cursor: 'pointer',
    left: '8px',
    position: 'absolute',
    top: '0px'
  },
  gridItem: {
    textAlign: 'start',
    width: '100%'
  },
  gridItemSwitches: {
    alignItems: 'center',
    border: '1px solid #CAD8FF',
    borderRadius: '12px',
    display: 'flex',
    height: '40px',
    justifyContent: 'space-between',
    marginTop: '16px',
    padding: '11px',
    width: '100%'
  },
  select: {
    marginTop: '16px'
  },
  selectHeader: {
    color: '#9BA0AD',
    fontFamily: 'Poppins',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    lineHeight: '100%',
    margin: '0px',
    transform: 'translate(-30px, 10px) scale(0.83)'
  },
  switchHeader: {
    color: 'black',
    fontFamily: 'Poppins',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    lineHeight: '100%',
    margin: '0px'
  }
});

const CategoryCreateModalBody = ({ options }) => {
  const dispatch = useDispatch();
  const categoryCreateDraft = useSelector(({ categories }) => categories.categoryCreateDraft);
  const classes = useStyles();

  return (
    <div>
      <div className={classes.gridItemSwitches}>
        <p className={classes.switchHeader}>Brand</p>
        <Switch
          checked={categoryCreateDraft?.descriptors?.brand ?? false}
          onChange={(e) => {
            dispatch(
              setCategoryCreateDraft({
                ...categoryCreateDraft,
                descriptors: { ...categoryCreateDraft.descriptors, brand: e }
              })
            );
          }}
        />
      </div>
      <div className={classes.gridItemSwitches}>
        <p className={classes.switchHeader}>Gender</p>
        <Switch
          checked={categoryCreateDraft?.descriptors?.gender ?? false}
          onChange={(e) => {
            dispatch(
              setCategoryCreateDraft({
                ...categoryCreateDraft,
                descriptors: { ...categoryCreateDraft.descriptors, gender: e }
              })
            );
          }}
        />
      </div>
      <div className={classes.gridItemSwitches}>
        <p className={classes.switchHeader}>Condition</p>
        <Switch
          checked={categoryCreateDraft?.descriptors?.condition ?? false}
          onChange={(e) => {
            dispatch(
              setCategoryCreateDraft({
                ...categoryCreateDraft,
                descriptors: {
                  ...categoryCreateDraft.descriptors,
                  condition: e
                }
              })
            );
          }}
        />
      </div>
      <div className={classes.gridItemSwitches}>
        <CStandardInput
          disableUnderline
          label="Category Type"
          onChange={(e) => {
            dispatch(
              setCategoryCreateDraft({
                ...categoryCreateDraft,
                type: e.target.value
              })
            );
          }}
          value={categoryCreateDraft?.type || ''}
          width="true"
        />
      </div>

      <div className={classes.gridItem}>
        <p className={classes.selectHeader}>Options</p>
        <MultipleSelect
          currentValue={categoryCreateDraft?.descriptors?.options || []}
          handleChange={(value) => {
            dispatch(
              setCategoryCreateDraft({
                ...categoryCreateDraft,
                descriptors: {
                  ...categoryCreateDraft.descriptors,
                  options: value
                }
              })
            );
          }}
          selectOptions={options}
          styles={{ marginTop: '16px' }}
          type="chip"
        />
      </div>
    </div>
  );
};

export default CategoryCreateModalBody;
